/* ENDURA — Open CART DRAWER after successful /cart/add */
(function () {
  const originalFetch = window.fetch;

  function openDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }
    return false;
  }

  window.fetch = async function (...args) {
    const res = await originalFetch.apply(this, args);

    try {
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url;

      if (url && url.includes('/cart/add')) {
        if (res.ok) {
          // Intento inmediato + reintento corto (Dawn re-renderiza cosas)
          setTimeout(openDrawer, 60);
          setTimeout(openDrawer, 180);
          setTimeout(openDrawer, 320);
        }
      }
    } catch (e) {}

    return res;
  };
})();
